import { setCurrentActiveEl, getCurrentActiveEl } from '@/core/directive/enterFocusTracker';

export default {
    mounted(el, binding) {
        el._vueInstance = binding.instance;
        const focusIndex = binding.value;

        // Save index directly on element for lookup
        el.dataset.focusIndex = focusIndex;

        // Auto-focus if index is 1 (optional or customizable)
        if (parseFloat(focusIndex) === 1) {
            setTimeout(() => {
                focusElement(el);
                setCurrentActiveEl(el);
            }, 100);
        }

        // Track on focus
        el.addEventListener('focus', () => {
            setCurrentActiveEl(el);
        });

        // Global enter handler (attach once)
        if (!window._enterHandlerAttached) {
            document.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter') return;

                const el = getCurrentActiveEl();
                if (!el) return;

                e.preventDefault();

                const vueInstance = el._vueInstance;
                const currentPos = parseFloat(el.dataset.focusIndex);
                if (isNaN(currentPos)) return;

                const onEnterFn = el.getAttribute('data-on-enter');
                if (onEnterFn && typeof vueInstance?.[onEnterFn] === 'function') {
                    vueInstance[onEnterFn]();
                }

                let nextPos = currentPos + 1;
                let nextEl = document.querySelector(`[data-focus-index="${nextPos}"]`);

                if (!nextEl) {
                    const overrideNext = el.getAttribute('data-next-focus');
                    if (overrideNext) {
                        nextPos = parseFloat(overrideNext);
                        nextEl = document.querySelector(`[data-focus-index="${nextPos}"]`);
                    }
                }

                if (!nextEl) return;

                setTimeout(() => {
                    focusElement(nextEl);
                    setCurrentActiveEl(nextEl);
                }, 150);
            });

            window._enterHandlerAttached = true;
        }
    }
};

function focusElement(el) {
    if (!el) return;

    const combobox = el.querySelector('[role="combobox"]');
    if (combobox) {
        combobox.focus();
        combobox.click();

        setTimeout(() => {
            const searchInput = el.querySelector('input[role="searchbox"]') || document.querySelector('input[role="searchbox"]');
            if (searchInput) {
                searchInput.focus();
                searchInput.select();
            }
        }, 100);
        return;
    }

    if (typeof el.focus === 'function') el.focus();
}
